export var InitiatorType;
(function (InitiatorType) {
    InitiatorType["INITIATOR_TYPE_USER"] = "USER";
    InitiatorType["INITIATOR_TYPE_API_CREDENTIALS"] = "API_CREDENTIALS";
})(InitiatorType || (InitiatorType = {}));
